import { render } from "./MainContentComponent.vue?vue&type=template&id=b9ad7398"
import script from "./MainContentComponent.vue?vue&type=script&lang=js"
export * from "./MainContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__